import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { toInt } from 'helpers/normalizers';

export default class DirectToResource extends Component {
  constructor(props) {
    super(props);
    this.validateInput = this.validateInput.bind(this);

    this.state = {
      formClass: '',
      url: '',
      value: '',
      error: false,
    };
  }

  handleInput = (e) => this.setState({ value: e.target.value });

  validateInput = (id) => {
    if (!id) {
      this.setState({ formClass: 'has-error', error: true });
      return false;
    }

    if (!toInt(id) || toInt(id) < 0) {
      this.setState({ formClass: 'has-error', error: true });
      return false;
    }

    this.setState({ formClass: 'has-success', error: false });
    return true;
  };

  handleEvents = (e) => {
    if (e.button !== 0 && e.which !== 13) return;
    const { value } = this.state;

    const { url } = this.props;
    const id = value;
    const isValid = this.validateInput(id);

    if (isValid) {
      let newUrl = url(toInt(id));
      this.setState({ url: newUrl });
    }
  };

  render() {
    const { label } = this.props;
    const { formClass, url, error } = this.state;

    if (url) {
      return <Redirect to={url} push />;
    }

    return (
      <div className={`form-group ${formClass}`}>
        <label className="control-label">{label}</label>
        <input
          type="number"
          className="form-control"
          onChange={this.handleInput}
          onKeyPress={this.handleEvents}
        />
        {error && (
          <div className="text-danger">Please enter a valid {label}</div>
        )}
        <br />
        <button className="btn btn-default" onClick={this.handleEvents}>
          Go
        </button>
      </div>
    );
  }
}
